import { render, staticRenderFns } from "./AddClaim.vue?vue&type=template&id=b90e901e&"
import script from "./AddClaim.vue?vue&type=script&lang=js&"
export * from "./AddClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports